import isVerifyTokenGuard from "@/guards/verifyTokenGuard";
import verifyTokenGuardWithoutPermission from "@/guards/verifyTokenGuardWithoutPermission";
import { challengeNavFlag } from '@/modules/waiting-room/daily-meditation/composables/usePlayerTheme'

const THEMED_ROUTES = new Set([
  'waiting-room-daily-meditation',
])

/** Evita flash de fondo al salir/entrar entre vistas con tema de player. */
export function registerDailyMeditationHooks(router) {
  router.beforeEach((to) => {
    challengeNavFlag.isChallengeDestination = THEMED_ROUTES.has(to.name)
  })
}

export default {
    name: "waiting-room",
    component: () => import(/* webpackChunkName: "users" */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: '',
            name: 'waiting-room-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [{
                    transKey: 'breadcrumbs.waiting-room-index',
                    isActive: true
                }]
            },
            component: () => import( /* webpackChunkName: "users-index" */ '@/modules/waiting-room/views/Index.vue'),
            props: true
            //props: {roomName: "39fd6428-5560-47cc-ad92-a7370e55fd65"}
        },
        {
            path: 'daily-meditation/:id',
            name: 'waiting-room-daily-meditation',
            beforeEnter: [verifyTokenGuardWithoutPermission],
            meta: {
                breadcrumbs: [{
                    transKey: 'breadcrumbs.waiting-room-index',
                    name: 'waiting-room-index'
                }, {
                    transKey: 'resources.challenges.dailyMeditation.fallbackTitle',
                    isActive: true
                }]
            },
            component: () => import(
                /* webpackChunkName: "waiting-room-daily-meditation" */
                '@/modules/waiting-room/daily-meditation/views/DailyMeditationDetailView.vue'
            ),
            props: true
        },
        {
            path: 'breathing',
            name: 'waiting-room-breathing',
            beforeEnter: [verifyTokenGuardWithoutPermission],
            meta: {
                breadcrumbs: [{
                    transKey: 'breadcrumbs.waiting-room-index',
                    name: 'waiting-room-index'
                }, {
                    transKey: 'breathing.title',
                    isActive: true
                }]
            },
            component: () => import(
                /* webpackChunkName: "waiting-room-breathing" */
                '@/modules/waiting-room/breathing/views/BreathingView.vue'
            ),
        },
        {
            path: 'life-line',
            name: 'life-line-index',
            // beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [{
                    transKey: 'breadcrumbs.life-line',
                    isActive: true
                }]
            },
            component: () => import( /* webpackChunkName: "users-index" */ '@/modules/waiting-room/views/LifeLine.vue')
        }
    ]
}
